import './Nav.css';
import React, { useState, useEffect } from 'react';
import logo from '../../assets/logo-no-bg.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import BurgerMenu from './BurgerMenu';

function Nav() {

  const [showMenu, setShowMenu] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showPortfolioOptions, setShowPortfolioOptions] = useState(false);
  const pathName = window.location.pathname;

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  const handleShowMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleShowPortfolioOptions = () => {
    setShowPortfolioOptions(!showPortfolioOptions);
  };

  return (
    <nav className={isSticky || (pathName.includes("contact") || pathName.includes("real-estate")) ? (showPortfolioOptions ? 'sticky expanded' : 'sticky') : ''}>
      <a href="/"><img src={logo} alt="logo" /></a>
      <ul>
        <li>
          <a href={(pathName.includes("contact") || pathName.includes("real-estate")) ? window.location.origin + "/#about" : "#about"}>Who We Are</a>
        </li>
        <li className={showPortfolioOptions ? 'show-nav-portfolio-options portfolio-nav-item' : 'portfolio-nav-item'}>
          <p style={{ cursor: "pointer", display: "flex", alignItems: "center" }} onClick={handleShowPortfolioOptions}>Our Portfolio <FontAwesomeIcon style={{ marginLeft: "5px", fontSize: "10px" }} icon={showPortfolioOptions ? faChevronUp : faChevronDown} /></p>
          <ul className="nav-portfolio-options">
            <li>
              <a href={(pathName.includes("contact") || pathName.includes("real-estate")) ? window.location.origin + "/#portfolio" : "#portfolio"} onClick={handleShowPortfolioOptions}>F&B</a>
            </li>
            <li>
              <a href="/real-estate">Real Estate</a>
            </li>
            <li>
              <a href={(pathName.includes("contact") || pathName.includes("real-estate")) ? window.location.origin + "/#pipeline" : "#pipeline"} onClick={handleShowPortfolioOptions}>Other Investments</a>
            </li>
          </ul>
        </li>
        <li>
          <a href="/contact">Contact Us</a>
        </li>
      </ul>
      <FontAwesomeIcon icon={faBars} className="burger" onClick={handleShowMenu} />
      <BurgerMenu showMenu={showMenu} closeMenu={() => setShowMenu(false)} />
    </nav>
  );
}

export default Nav;